import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CmsAuthService } from '../services/cms-auth.service';
import { environment } from '@cms_root/environments/environment';

@Injectable()
export class AuthHeadersInterceptor implements HttpInterceptor {
  private _apiKey = environment.cmsApiKey;
  private _apiKeyBase64 = 'Basic ' + btoa(this._apiKey);

  constructor(private readonly cmsAuthService: CmsAuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers = request.headers;

    if (!request.headers.has('X-Client')) {
      headers = headers.append('X-Client', this._apiKeyBase64);
    }

    if (this.cmsAuthService.isAuth && !request.headers.has('Authorization')) {
      const token = this.cmsAuthService.getTokenFromLocalStorage();

      if (token) {
        headers = headers.append('Authorization', `Bearer ${token}`);
      }
    }

    const authRequest = request.clone({ headers });

    return next.handle(authRequest);
  }
}
